const beijingHourFormatter = new Intl.DateTimeFormat('en-US', {
  timeZone: 'Asia/Shanghai',
  hour: 'numeric',
  hourCycle: 'h23',
});

/** Return the sky period for an instant in Beijing time, regardless of device timezone. */
export const getBeijingPeriod = (date = new Date()) => {
  const hour = Number(
    beijingHourFormatter.formatToParts(date).find(part => part.type === 'hour').value
  );

  if (hour >= 6 && hour < 17) return 'day';
  if (hour >= 17 && hour < 19) return 'dusk';
  return 'night';
};
